import { StringUtility } from "@common/utils";
import { IModel, ModelRecord } from "@common/models";
import { defaultTo } from "lodash";

export interface IHospitalScheduleTemplateListingModel extends IModel {
    hospitalScheduleTemplateId: number,
    hospitalId: number,
    name: string,
    isDefault: boolean,
    isActive: boolean;
    color: string | undefined,
    hasSchedulePreferences: boolean,
    schedulePreferenceCount: number
}

export class HospitalScheduleTemplateListingModel implements ModelRecord<IHospitalScheduleTemplateListingModel> {
    rowVersion: string
    hospitalScheduleTemplateId: number;
    hospitalId: number;
    name: string;
    isDefault: boolean;
    isActive: boolean;
    color: string | undefined;
    hasSchedulePreferences: boolean;
    schedulePreferenceCount: number;


    constructor(init: IHospitalScheduleTemplateListingModel) {
        this.rowVersion = defaultTo(init.rowVersion, '');
        this.hospitalScheduleTemplateId = defaultTo(init.hospitalScheduleTemplateId, 0);
        this.hospitalId = defaultTo(init.hospitalId, 0);
        this.name = init.name;
        this.color = StringUtility.SanitizeString(init.color ?? '#2596be');
        this.isActive = defaultTo(init.isActive, false);
        this.isDefault = defaultTo(init.isDefault, false);
        this.hasSchedulePreferences = defaultTo(init.hasSchedulePreferences, false);
        this.schedulePreferenceCount = defaultTo(init.schedulePreferenceCount, 0);
    }
}
